<template>
  <v-autocomplete
    v-model="selectedCustomerId"
    :loading="loading"
    :items="customers"
    :search-input.sync="search"
    item-text="name"
    item-value="id"
    autocomplete="off"
    hide-details
    label="Hae"
    placeholder=" "
    dense
    prepend-inner-icon="search"
    outlined
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title v-if="!search || (search && search.length < 3)">
          Syötä vähintään
          <strong>3</strong>
          kirjainta.
        </v-list-item-title>
        <v-list-item-title v-else>
          Ei hakutuloksia
        </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        small
        :input-value="data.selected"
        @click="data.select"
      >
        <v-avatar left>
          <v-icon>person</v-icon>
        </v-avatar>
        {{ data.item.name }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <template>
        <v-list-item-avatar>
          <v-icon>person</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="data.item.name"/>
          <v-list-item-subtitle v-text="data.item.ssn"/>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>
<script>
import _ from 'lodash';
import { apiPost } from '../api';
import { EventBus } from '@/utils';

export default {
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    selectedCustomerId: null,
    loading: false,
    timerId: null,
    search: null,
    customers: [],
  }),
  watch: {
    search(val) {
      if (val) {
        this.querySelections(val);
      }
    },
    selectedCustomerId: {
      async handler(val) { // eslint-disable-line
        if (val) {
          const {
            name, phone, email, id,
          } = _.cloneDeep(this.customers.find(c => c.id === val));
          this.customer.name = name;
          this.customer.phone = phone;
          this.customer.email = email;
          this.customer.id = id;
        } else {
          this.customer.name = '';
          this.customer.phone = '';
          this.customer.email = '';
          delete this.customer.id;
        }
      },
      deep: true,
    },
  },
  mounted() {
    EventBus.$on('FORM_RESET', this.resetCustomer);
  },
  methods: {
    resetCustomer() {
      this.selectedCustomerId = null;
      this.customer.name = '';
      this.customer.phone = '';
      this.customer.email = '';
      delete this.customer.id;
    },
    async querySelections(payload) {
      if (payload === '' || (payload && payload.length < 3)) {
        return;
      }
      this.loading = true;
      this.searchQustomersDebounced(payload);
    },
    searchQustomersDebounced(payload) {
      clearTimeout(this.timerId);
      const _this = this;
      this.timerId = setTimeout(async () => {
        const response = await apiPost('customer/search', { query: payload });
        _this.customers = response.result;
        _this.loading = false;
      }, 500);
    },
  },
};
</script>
